import { apiClient } from './apiClient';

export interface Tenant {
  id: string;
  name: string;
  domain: string;
  is_active: boolean;
  created_at: string;
  users_count?: number;
}

export interface User {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  role: 'admin' | 'sales' | 'employee';
  phone?: string;
  is_active: boolean;
  tenant: Tenant;
  created_at: string;
}

export interface TenantStats {
  tenant: Tenant;
  users: {
    total: number;
    active: number;
    recent: number;
    role_distribution: Array<{
      role: string;
      count: number;
    }>;
  };
}

export interface CreateUserData {
  email: string;
  first_name: string;
  last_name: string;
  role: 'admin' | 'sales' | 'employee';
  phone?: string;
  password: string;
}

export interface UpdateUserData {
  first_name?: string;
  last_name?: string;
  role?: 'admin' | 'sales' | 'employee';
  phone?: string;
  is_active?: boolean;
}

export interface UpdateTenantData {
  name?: string;
  domain?: string;
}

export const tenantService = {
  // Tenant Management
  async getTenant(): Promise<Tenant> {
    return apiClient.get('/tenant/');
  },

  async updateTenant(data: UpdateTenantData): Promise<Tenant> {
    return apiClient.patch('/tenant/', data);
  },

  async getTenantStats(): Promise<TenantStats> {
    return apiClient.get('/tenant/stats/');
  },

  // User Management
  async getUsers(): Promise<User[]> {
    const response = await apiClient.get('/users/');
    // Handle paginated response
    return response.results || response;
  },

  async createUser(data: CreateUserData): Promise<User> {
    return apiClient.post('/users/', data);
  },

  async getUser(userId: string): Promise<User> {
    return apiClient.get(`/users/${userId}/`);
  },

  async updateUser(userId: string, data: UpdateUserData): Promise<User> {
    return apiClient.patch(`/users/${userId}/`, data);
  },

  async deleteUser(userId: string): Promise<void> {
    return apiClient.delete(`/users/${userId}/`);
  },
};
